export default __webpack_public_path__ + "static/media/portfolio-55.641e7c97.jpg";